import { jsx } from 'react/jsx-runtime';
import { createGlobalReferenceContext } from '@flex-packages/shared-react';
import { useContext, useMemo } from 'react';

const EventPropertyContext = createGlobalReferenceContext("event-property-context", void 0);
const EventPropertyBoundary = ({
  properties,
  children
}) => {
  const upperEventProperties = useContext(EventPropertyContext);
  const value = useMemo(
    () => ({ ...upperEventProperties, ...properties }),
    [properties, upperEventProperties]
  );
  return /* @__PURE__ */ jsx(EventPropertyContext.Provider, { value, children });
};

export { EventPropertyBoundary, EventPropertyContext };
//# sourceMappingURL=eventPropertyBoundary.mjs.map
